var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VApp',{},[_c('AppHeader',{attrs:{"elevation":"0"}}),_c('NotificationBar'),_c('VMain',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('RouterView')],1)],1),(!_vm.$maintenanceEnabled)?_c('AppFooter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }